// 英语学科页：按材料类别分区，包含伊索寓言与 RAZ 分级阅读。
import { el, routeLink, topbar } from "../lib";
import { PATHS } from "../../shared/navigation";

export function englishView(root: HTMLElement): void {
  document.title = "英语 · 小朋友学习乐园";
  root.appendChild(topbar([{ label: "英语" }]));

  const main = el("main", "wrap main-pad english-materials");

  main.appendChild(el("h2", "section-title", "英语学习材料"));
  const materials = el("div", "material-grid");
  const textbook = routeLink(PATHS.textbook2a, "material-card mc-english");
  textbook.appendChild(el("div", "mc-emoji", "🎧"));
  const textbookBody = el("div", "mc-body");
  textbookBody.appendChild(el("div", "mc-name", "二年级上册"));
  textbookBody.appendChild(el("div", "mc-sub", "新版课本 · 6 个单元 · 音频与视频"));
  textbook.append(textbookBody, el("div", "mc-go", "▶"));
  materials.appendChild(textbook);

  const aesop = routeLink(PATHS.aesop, "material-card mc-english");
  aesop.appendChild(el("div", "mc-emoji", "🐢"));
  const mcBody = el("div", "mc-body");
  mcBody.appendChild(el("div", "mc-name", "伊索寓言"));
  mcBody.appendChild(el("div", "mc-sub", "30 个 Flash 故事 · 配套音频"));
  aesop.appendChild(mcBody);
  aesop.appendChild(el("div", "mc-go", "▶"));
  materials.appendChild(aesop);

  const raz = routeLink(PATHS.raz, "material-card mc-english");
  raz.appendChild(el("div", "mc-emoji", "📚"));
  const body = el("div", "mc-body");
  body.appendChild(el("div", "mc-name", "RAZ 分级阅读"));
  body.appendChild(el("div", "mc-sub", "A 级 · 绘本、音频、视频"));
  raz.appendChild(body);
  raz.appendChild(el("div", "mc-go", "▶"));
  materials.appendChild(raz);
  main.appendChild(materials);
  root.appendChild(main);
}
